import { Role, RouteInfo } from '@app/shared/common';

/**
 * @description
 * Here you can define all menu items from main sidebar menu
 * @see RouteInfo interface for all posible item configurations
 */
export const ROUTES: RouteInfo[] = [
  {
    path: '/upload',
    title: 'Upload',
    icon: 'pi pi-file-import',
  },
  {
    path: '/invoices',
    title: 'Invoices',
    icon: 'pi pi-book',
  },
];
